import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => {
	return {
		footer: {
			alignSelf : "start",
			cursor    : "pointer",
			color     : `${ theme.other.paletteNew.primaryDarkBlue } !important`,
			marginTop : "auto",
			fontSize  : "1.6rem"
		}
	};
} );
